"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var react_1 = require("react");
var styles_1 = require("../../styles");
var global_styles_1 = require("../../styles/global.styles");
exports.Toggle = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, restProps = __rest(_a, ["label", "value", "onChange"]);
    var _b = react_1.useState(value), toggle = _b[0], setToggle = _b[1];
    react_1.useEffect(function () {
        setToggle(value);
    }, [value]);
    return (React.createElement(LabelContainer, __assign({}, restProps),
        label,
        React.createElement(ToggleContainer, { label: label, onClick: function () {
                var value = !toggle;
                if (!!onChange)
                    onChange(value);
                setToggle(value);
            } },
            React.createElement(ToggleTrack, { toggle: toggle },
                React.createElement(ToggleTrackText, { yes: true }, "Yes"),
                React.createElement(ToggleTrackText, null, "No")),
            React.createElement(ToggleSelector, { toggle: toggle }))));
};
var LabelContainer = styled_1.default.div(__assign(__assign({}, global_styles_1.toggle.label.container), global_styles_1.toggle.text.label));
var ToggleContainer = styled_1.default.div(function (props) { return (__assign(__assign({}, global_styles_1.toggle.container), { position: 'relative', marginLeft: !!props.label && styles_1.spacing.md + "px" })); });
var ToggleTrack = styled_1.default.div(function (props) { return (__assign(__assign(__assign({}, global_styles_1.toggle.text.track), global_styles_1.toggle.track), { background: props.toggle ? styles_1.palette['turquoise'] : styles_1.palette['grey-base'], transition: styles_1.transition })); });
var ToggleTrackText = styled_1.default.span(function (props) { return (__assign(__assign({}, global_styles_1.toggle.text.track), { color: props.yes && styles_1.palette['white-base'] })); });
var ToggleSelector = styled_1.default.div(function (props) { return (__assign(__assign({}, global_styles_1.toggle.selector), { background: props.toggle ? styles_1.palette['white-base'] : styles_1.palette['stone-base'], left: props.toggle ? '32px' : '0px', transition: styles_1.transition })); });
//# sourceMappingURL=Toggle.js.map